import { GetClubBySlugQuery } from 'graphql/generated/scheme'
import { CLUB_PERMISSIONS } from './constants'
import { ManageClubType } from 'graphql/type'

type ClubType = GetClubBySlugQuery['clubBySlug']
type PermissionType = (typeof CLUB_PERMISSIONS)[keyof typeof CLUB_PERMISSIONS]

/**
 * Check if a user has a specific club permission
 *
 * @param club - The club object to check permissions against
 * @param permission - The permission name to check (from CLUB_PERMISSIONS)
 * @returns true if the user has the permission, false otherwise
 *
 * @example
 * ```tsx
 * if (hasPermission(club, CLUB_PERMISSIONS.CAN_MANAGE_CLUB)) {
 *   // Show manage club button
 * }
 * ```
 */
export function hasClubPermission(
	club: ClubType | null | undefined | ManageClubType,
	permission: PermissionType
): boolean {
	if (!club?.permissions) {
		return false
	}
	return club.permissions.some(p => p?.name === permission)
}
